module.exports = __webpack_public_path__ + "img/number-thumb-14.3bc4ad7b.jpg";